import React from 'react';
import { Route, Switch } from 'react-router-dom';
import AccessControl from '../../../../AccessControl';
import {
  PERMISSIONS_KEY,
  PERMISSION_TYPE,
  ROUTES,
} from '../../../../common/constants';
import CreateUserPayoutLink from './pages/CreateUserPayoutLink';
import EditUserPayoutLink from './pages/EditUserPayoutLink';
import UserPayoutLinks from './pages/UserPayoutLinks';
import ViewUserPayoutLink from './pages/ViewUserPayoutLink';

const UserPayoutLinksWrapper = () => (
  <Switch>
    <Route
      exact
      path={`${ROUTES?.PAYMENTS}${ROUTES?.USER_PAYOUT_LINKS}`}
      render={(props) => (
        <AccessControl permissionKey={PERMISSIONS_KEY?.OFFERS_PAYOUT_LINK}>
          <UserPayoutLinks {...props} />
        </AccessControl>
      )}
    />
    <Route
      exact
      path={`${ROUTES?.PAYMENTS}${ROUTES?.USER_PAYOUT_LINKS}/add`}
      render={(props) => (
        <AccessControl
          permissionType={PERMISSION_TYPE?.CREATE}
          permissionKey={PERMISSIONS_KEY?.OFFERS_PAYOUT_LINK}
        >
          <CreateUserPayoutLink {...props} />
        </AccessControl>
      )}
    />
    <Route
      exact
      path={`${ROUTES?.PAYMENTS}${ROUTES?.USER_PAYOUT_LINKS}/edit/:id`}
      render={(props) => (
        <AccessControl
          permissionType={PERMISSION_TYPE?.UPDATE}
          permissionKey={PERMISSIONS_KEY?.OFFERS_PAYOUT_LINK}
        >
          <EditUserPayoutLink {...props} />
        </AccessControl>
      )}
    />
    <Route
      exact
      path={`${ROUTES?.PAYMENTS}${ROUTES?.USER_PAYOUT_LINKS}/view/:id`}
      render={(props) => (
        <AccessControl
          permissionType={PERMISSION_TYPE?.UPDATE}
          permissionKey={PERMISSIONS_KEY?.OFFERS_PAYOUT_LINK}
        >
          <ViewUserPayoutLink {...props} />
        </AccessControl>
      )}
    />
  </Switch>
);

export default UserPayoutLinksWrapper;
